import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import About from "./components/About";
import Wine from "./components/Wine";
import NavBar from "./components/NavBar";


function App() {
  return (
    <BrowserRouter>
    <NavBar></NavBar>
      <Routes>
        <Route element={<Home/>} exact="true" path='/' />
        <Route element={<About/>} path='/about' />
        <Route element={<Wine/>} path='/wine' />
      </Routes>
    </BrowserRouter>

  );
}

export default App;
